export const GET_USER_INFO = () => {
  return `query {
    pilotUserInfo {
      displayName
      givenName
      email
      isActive
      surName
      regId
      userId
      remainingSearchCount
      userCategory
      role {
        roleName
      }
      userCompany {
        companyCode
        companyId
        companyName
        description
        logo
        notes
        url
      }
    }
  }`;
};
export const ADD_FEEDBACK = (param) => {
  let answer = null;
  if (param?.answer) {
    answer =
      param.feedbackType === 4 ? `"${param.answer}"` : `"""${param.answer}"""`;
  }
  return `mutation {
  pilotAddFeedback(
    input: {
      question: "${param.question}"
      answer: ${answer}
      companyId: ${param.companyId}
      feedbackId: ${param.feedbackId}
      ratingCount: ${param?.rating}
      ratingDescription: "${param?.comment}"
      commentDescription: "${param?.comment}"
      type: ${param?.feedbackType}
      likeStatus: ${param?.likeStatus}
      experienceRadioCheck: ${param?.experience}
    }
  ) {
    success
    message
    data {
      feedbackId
    }
  }
}`;
};
export const WISE_AI_SEARCH = (param) => {
  return `mutation {
    wiseAiSearch(
      input: {
        companyCode: "${param?.companyCode}"
        companyId: ${param?.companyId}
        question: "${param?.question}"
        userId: ${param?.userId}
      }
    ) {
      answer
      message
      success
      feedbackSavedMessage
      remainingSearchCount
      feedbackId
    }
  }`;
};
